<template>
  <b-dropdown-item v-if="!inScud" @click="$emit('send-to-scud')">
    <img :src="iconPath('v_scud.svg')" alt="" class="icon-pdf">
    Передать в СКУД
  </b-dropdown-item>
</template>

<script>
import mainMixin from '@/common/mixins/mainMixin';
export default {
  mixins: [mainMixin],

  props: {
    applicationId: Number,
    personalId: Number,
    transportId: Number,

    inScud: {
      type: Boolean,
      default: true
    },

    visitor: {
      type: Object,
      default: () => ({})
    },

    transportIndex: {
      type: Number,
      default: 0
    }
  },

  methods: {
    iconPath(baseName) {
      return require('@/common/assets/img/icons/menuVisitor/' + baseName)
    }
  }
}
</script>
